/**
 * ConsumptionCertificate — registry entry (Component only; completeness is registered
 * separately in `modules/completeness.ts` per the A-01 split).
 */

import type { PfConfigModule } from '../registry'
import { ConsumptionCertificate } from './ConsumptionCertificate.component'

export const consumptionCertificateModule: PfConfigModule = {
  flowId: 'consumption_certificate',
  Component: ConsumptionCertificate,
}
